import { Dictionary } from '../types/Dictionary';

import { BaseBlock } from '../blocks/base-block';
import { ContentBlock } from '../blocks/common/content/content';
import ApartmentHeadingBlock from '../blocks/apartment-detail/apartment-heading/apartment-heading';
import { ApartmentInfoBlock } from '../blocks/apartment-detail/apartment-info/apartment-info';
import { ApartmentSpecialEquipmentBlock } from '../blocks/apartment-detail/apartment-special-equipment/apartment-special-equipment';
import { ApartmentGalleryBlock } from '../blocks/apartment-detail/apartment-gallery/apartment-gallery';
import { ApartmentViewsBlock } from '../blocks/apartment-detail/apartment-views/apartment-views';
import { ApartmentProjectStatusBlock } from '../blocks/apartment-detail/apartment-project-status/apartment-project-status';
import { ApartmentClientChangesDeadlinesBlock } from '../blocks/apartment-detail/apartment-client-changes-deadlines/apartment-client-changes-deadlines';
import { ApartmentSimilarProductsBlock } from '../blocks/apartment-detail/apartment-similar-products/apartment-similar-products';
import { ApartmentFaqBlock } from '../blocks/apartment-detail/apartment-faq/apartment-faq';
import { ApartmentButtonsBlock } from '../blocks/apartment-detail/apartment-buttons/apartment-buttons';
import { ApartmentAdditionalCostFeaturesBlock } from '../blocks/apartment-detail/apartment-additional-cost-features/apartment-additional-cost-features';
import { ApartmentSearchHeadingBlock } from '../blocks/apartment-search/apartment-search-heading/apartment-search-heading';
import { ApartmentSearchFormBlock } from '../blocks/apartment-search/apartment-search-form/apartment-search-form';
import { ApartmentSearchResultBlock } from '../blocks/apartment-search/apartment-search-result/apartment-search-result';
import { ApartmentSearchInfoBlock } from '../blocks/apartment-search/apartment-search-info/apartment-search-info';
import { ApartmentsLocationsHeadingBlock } from '../blocks/apartments-locations/apartments-locations-heading/apartments-locations-heading';
import { ApartmentsLocationsOverviewProjectsBlock } from '../blocks/apartments-locations/apartments-locations-overview-projects/apartments-locations-overview-projects';
import { ApartmentsLocationsLocationBlock } from '../blocks/apartments-locations/apartments-locations-location/apartments-locations-location';
import { ApartmentsLocationsSearchBlock } from '../blocks/apartments-locations/apartments-locations-search/apartments-locations-search';
import { ApartmentsOverviewHeadingBlock } from '../blocks/apartments-overview/apartments-overview-heading/apartments-overview-heading';
import { ApartmentsOverviewSearchBlock } from '../blocks/apartments-overview/apartments-overview-search/apartments-overview-search';
import { ApartmentsOverviewResultBlock } from '../blocks/apartments-overview/apartments-overview-result/apartments-overview-result';
import { ApartmentsOverviewNoticeBlock } from '../blocks/apartments-overview/apartments-overview-notice/apartments-overview-notice';
import { ApartmentsOverviewFaqBlock } from '../blocks/apartments-overview/apartments-overview-faq/apartments-overview-faq';
import { ApartmentsOverviewInfoBlock } from '../blocks/apartments-overview/apartments-overview-info/apartments-overview-info';
import { ApartmentLocationHeadingBlock } from '../blocks/apartment-location/apartment-location-heading/apartment-location-heading';
import { ApartmentLocationSearchBlock } from '../blocks/apartment-location/apartment-location-search/apartment-location-search';
import { ApartmentLocationDetails } from '../blocks/apartment-location/apartment-location-details/apartment-location-details';
import { ApartmentLocationInfoBlock } from '../blocks/apartment-location/apartment-location-info/apartment-location-info';
import { ApartmentLocationMapBlock } from '../blocks/apartment-location/apartment-location-map/apartment-location-map';
import { ApartmentLocationStandardFinishBlock } from '../blocks/apartment-location/apartment-location-standard-finish/apartment-location-standard-finish';
import { ApartmentLocationFaqBlock } from '../blocks/apartment-location/apartment-location-faq/apartment-location-faq';
import { ApartmentLocationProjectGalleryBlock } from '../blocks/apartment-location/apartment-location-project-gallery/apartment-location-project-gallery';
import { ApartmentLocationCountUpBlock } from '../blocks/apartment-location/apartment-location-count-up/apartment-location-count-up';
import { ApartmentSearchBarBlock } from '../blocks/common/apartment-search-bar/apartment-search-bar';
import { PageMetaBlock } from '../blocks/common/page-meta/page-meta';
import { PageMetaApartmentBlock } from '../blocks/common/page-meta-apartment/page-meta-apartment';
import { PageMetaLocationBlock } from '../blocks/common/page-meta-location/page-meta-location';
import { HomepageRegistrationForm } from '../blocks/common/hp-registration-form/hp-registration-form';
import { UniversalForm } from '../blocks/common/universal-form/universal-form';
import { RegistrationFormModal } from '../blocks/common/registration-form-modal/registration-form-modal';
import { ReservationFormModal } from '../blocks/common/reservation-form-modal/reservation-form-modal';
import { FavoriteProductsHeadingBlock } from '../blocks/favorite-products/favorite-products-heading/favorite-products-heading';
import { FavoriteProductsListBlock } from '../blocks/favorite-products/favorite-products-list/favorite-products-list';
import { FavoriteProductsUserRegFormBlock } from '../blocks/favorite-products/favorite-products-user-reg-form/favorite-products-user-reg-form';

export const blockComponentsByKey: Dictionary<typeof BaseBlock> = {
	'apartment-search-bar': ApartmentSearchBarBlock,
	'hp-registration-form': HomepageRegistrationForm,
	'content': ContentBlock,
	'page-meta': PageMetaBlock,
	'page-meta-apartment': PageMetaApartmentBlock,
	'page-meta-location': PageMetaLocationBlock,
	'universal-form': UniversalForm,
	'registration-form-modal': RegistrationFormModal,
	'reservation-form-modal': ReservationFormModal,

	'apartment-heading': ApartmentHeadingBlock,
	'apartment-gallery': ApartmentGalleryBlock,
	'apartment-info': ApartmentInfoBlock,
	'apartment-views': ApartmentViewsBlock,
	'apartment-special-equipment': ApartmentSpecialEquipmentBlock,
	'apartment-additional-cost-features': ApartmentAdditionalCostFeaturesBlock,
	'apartment-client-changes-deadlines': ApartmentClientChangesDeadlinesBlock,
	'apartment-project-status': ApartmentProjectStatusBlock,
	'apartment-similar-products': ApartmentSimilarProductsBlock,
	'apartment-faq': ApartmentFaqBlock,
	'apartment-buttons': ApartmentButtonsBlock,

	'apartments-locations-heading': ApartmentsLocationsHeadingBlock,
	'apartments-locations-overview-projects': ApartmentsLocationsOverviewProjectsBlock,
	'apartments-locations-search': ApartmentsLocationsSearchBlock,
	'apartments-locations-location': ApartmentsLocationsLocationBlock,

	'apartment-search-heading': ApartmentSearchHeadingBlock,
	'apartment-search-form': ApartmentSearchFormBlock,
	'apartment-search-result': ApartmentSearchResultBlock,
	'apartment-search-info': ApartmentSearchInfoBlock,

	'apartments-overview-heading': ApartmentsOverviewHeadingBlock,
	'apartments-overview-search': ApartmentsOverviewSearchBlock,
	'apartments-overview-result': ApartmentsOverviewResultBlock,
	'apartments-overview-notice': ApartmentsOverviewNoticeBlock,
	'apartments-overview-faq': ApartmentsOverviewFaqBlock,
	'apartments-overview-info': ApartmentsOverviewInfoBlock,

	'apartment-location-heading': ApartmentLocationHeadingBlock,
	'apartment-location-search': ApartmentLocationSearchBlock,
	'apartment-location-details': ApartmentLocationDetails,
	'apartment-location-info': ApartmentLocationInfoBlock,
	'apartment-location-map': ApartmentLocationMapBlock,
	'apartment-location-project-gallery': ApartmentLocationProjectGalleryBlock,
	'apartment-location-standard-finish': ApartmentLocationStandardFinishBlock,
	'apartment-location-faq': ApartmentLocationFaqBlock,
	'apartment-location-count-up': ApartmentLocationCountUpBlock,
	'favorite-products-heading': FavoriteProductsHeadingBlock,
	'favorite-products-list': FavoriteProductsListBlock,
	'favorite-products-user-reg-form': FavoriteProductsUserRegFormBlock,

};
